module.exports = __webpack_public_path__ + "img/mpos-devices.72d48bd2.svg";